import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { PropsWithChildren } from 'react'
import DropdownItem from './DropdownItem'
import EllipsisIcon from '../icons/EllipsisIcon'
import DropdownSeparator from './DropdownSeparator'
import classNames from 'classnames'
import DropdownSub from './DropdownSub'

type DropdownProps = {
  isDisabled?: boolean
  horizontal?: boolean
  buttonContentOverride?: React.ReactNode
  buttonClassName?: string
} & PropsWithChildren

const Dropdown = ({ isDisabled = false, horizontal = false, buttonContentOverride, buttonClassName, children }: DropdownProps) => {
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger
        className={classNames('rounded-sm p-1 transition-all outline-none', {
          'cursor-not-allowed': isDisabled,
          'hover:bg-gray-100': !isDisabled,
        }, buttonClassName)}
      >
        {
          !buttonContentOverride
          && (
            <>
              {
                horizontal
                  ? <EllipsisIcon className="w-4 h-4 rotate-90" />
                  : <EllipsisIcon className="w-4 h-4" />
              }
            </>
          )
        }
        {
          buttonContentOverride
          && (
            <>
              {buttonContentOverride}
            </>
          )
        }
      </DropdownMenu.Trigger>

      <DropdownMenu.Portal>
        <DropdownMenu.Content className="z-50 mt-2 w-56 rounded-[5px] bg-gray-900 shadow-lg focus:outline-none p-[5px] flex gap-[5px] flex-col animate-dropdown">
          {children}
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  )
}

Dropdown.Item = DropdownItem
Dropdown.Separator = DropdownSeparator
Dropdown.Sub = DropdownSub

export default Dropdown
